import React, { useEffect, useState } from 'react';
import SearchBar from '../explore/searchBar/searchBar';
import {useTranslation} from "react-i18next";

function SharePopup({id, dataList, open, setOpen}) {
    const { t } = useTranslation();
    const [search, setSearch] = React.useState("");
    const [selected,setSelected] = React.useState([]);
    const [filterDisplay, setFilterDisplay] = React.useState([]);


    function sharePost(){
        selected.forEach(user_id => {
            window._converse.reticular.sharePost(user_id, id);
        });
    }

    useEffect(() => {
        setSearch(search);
        let oldList = dataList;

        if(search !== ""){
            let newList = [];
            newList = oldList.filter(c =>
                c.firstname.toUpperCase().includes(search.toUpperCase()) || c.lastname.toUpperCase().includes(search.toUpperCase())
            );
            setFilterDisplay(newList);
        }else{
            setFilterDisplay(dataList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const handleChange = event => {
        setSearch(event);
    }

    const refresh = ()=>{
        setSearch('');
        setFilterDisplay([]);
    }

    function ClosePopup(){
        setOpen(false);
        refresh();
    }

    function UserItem({user, contacts}){
        const {id,img, firstname, lastname} = user;

        let span;
        let contact_img;

        if(img === undefined || img === null){
            contact_img = <span className="c-contact_img-replace">{firstname[0].toUpperCase()}{lastname[0].toUpperCase()}</span>
        }else{
            contact_img = <img alt="" className="c-contact_img" style={{width: "50px", height: "50px"}} src={img} />
        }

        function handleChange(event, item){
            const isChecked = event.target.checked;
            if(isChecked){
                setSelected([...selected, item.id]);
            }else{
                let newList = selected.filter(c =>
                    c !== item.id
                );
                setSelected(newList);
            }
        }

        return (
            <>
                <div className={`c-contact ${id}`}>
                    <div className="c-contact_infos">
                        {contact_img}
                        <div className="c-infos">
                            <p>{firstname} {lastname}</p>
                            { span }
                        </div>
                    </div>
                    <input type="checkbox" className="c-contact_checkbox" name="contacts" checked={selected.includes(user.id)} onChange={(e) => handleChange(e, user)}/>
                </div>
            </>
        )
    }


    let data_list = [];
    if(search.length < 1){
        data_list = dataList;
    }else{
        data_list = filterDisplay;
    }

    let view;

        view = <>
            <div className="c-popup_searchbar">
                <SearchBar value={search} handleChange={e => handleChange(e.target.value)}/>
            </div>
            <div className="c-popup_search">
                {
                    data_list.map(c => {
                        return <UserItem user={c} key={c.id} />
                    })}
            </div>
        </>

    return (
        <>
            <div className={`c-container_bg ${open ? "active" : ""}`} >
                <div className="c-popup_div">
                    <div className="c-popup_header">
                        <span className="c-popup_close" onClick={ClosePopup} />
                        <p>{t('Partager par message privé')}</p>
                        <button type="button" className="c-valid_button" onClick={(e) => { sharePost();setOpen(false);}}>{t('Envoyer')}</button>
                    </div>
                    <div className="c-popup_content">
                        { view }
                    </div>
                </div>
            </div>
        </>
    )
}



export default SharePopup;
